import { useContext } from "react";
import { ChangeLanguageContext } from "../LanguageContext";

export function useLanguage() {
  return useContext(ChangeLanguageContext);
}